// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3837cf3c","453":"d41d58ff","455":"822fc773","977":"6bee0817"}[chunkId] + ".chunk.js";
};